<template>
<div class="text-center my-16">
  <v-progress-circular
      size="30"
      width="4"
      indeterminate
      color="black"
  ></v-progress-circular>
</div>
</template>

<script>
export default {
  name: "loading",
  data(){
    return{
      model:true
    }
  }
}
</script>

<style scoped>

</style>